import { MbeInfo } from '@/components/icons';
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Text,
  Link,
} from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';

export const PopoverInfo: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Popover
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={false}
      gutter={16}
      trigger="hover"
    >
      <PopoverTrigger>
        <MbeInfo
          _hover={{ color: 'white', bg: 'brand.red.light' }}
          color="brand.red.light"
          fontSize="h4"
          ml={2}
          rounded="full"
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent bgColor="brand.black" borderRadius={0} color="white" fontSize={14} p={4}>
          <PopoverArrow bgColor="brand.black" />
          <PopoverHeader borderBottom="0" fontWeight="bold">
            {t('FORM.EXTRA_SERVICE_INSURANCE_INFO_TITLE')}
          </PopoverHeader>
          <PopoverBody>
            <Text>
              <Trans
                components={{
                  url: (
                    <Link
                      color="brand.red.light"
                      href={t('FORM.EXTRA_SERVICE_INSURANCE_LINK')}
                      isExternal
                    />
                  ),
                }}
                i18nKey={'FORM.EXTRA_SERVICE_INSURANCE_INFO_TEXT'}
              />
            </Text>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
